import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      color: '#7596e2',
      height: '0',
    },
    to: {
      opacity: 1,
      color: 'white',
      height: '24px',
    },
  },
  appUpdateBar: {
    animation: '$fadeIn 1s ease-in',
    animationFillMode: 'forwards',
    animationDuration: '2s',
    animationDelay: '2s',
    position: 'absolute',
    top: 0,
    zIndex: 999,
    width: '100%',
    opacity: 0,
    height: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#7596e2',
    fontWeight: '500',
    cursor: 'pointer',
    userSelect: 'none',
    fontSize: '15px',
  },
}));

export default useStyles;
